/* eslint-disable react/jsx-no-bind */
import * as React from "react";
import * as _ from "underscore";
import { connect } from "react-redux";

import { AppShape, HurdleShape, DocTypes } from "@eave/shared/types/api";
import HurdleView from "underwriter_dashboard/shared/HurdleView";
import DocEntry from "../shared/DocEntry";
import { loadApp } from "../actions";
import APIClient from "../../APIClient";

// TODO: jjw: very similar to FloodInsuranceEditor; refactor as one
/* HazardInsuranceEditor */

interface HurdleEditorProps {
  dispatch?: Function;
  app: AppShape;
  hurdle: HurdleShape;
  onHide: Function;
}

class HazardInsuranceEditor extends React.Component<HurdleEditorProps, any> {
  constructor(props) {
    super(props);
  }

  onSave(data): Promise<any> {
    // create contact from Provider Name
    if (data && data.insurance_provider && data.insurance_provider.provider_name) {
      const providerName = data.insurance_provider.provider_name;
      const providerContact = {
        loan_application_id: this.props.app.id,
        role: "HazardInsuranceCompany",
        source: "HazardInsuranceHurdle",
        name: providerName,
      };
      return APIClient.post(`/contacts`, providerContact);
    }
  }

  getDocByType(docType) {
    return _.chain(this.props.app.documents)
      .filter((d: any) => d.type === docType)
      .sortBy((d: any) => -1 * parseInt(d.id, 10)) // most recent
      .first()
      .value();
  }

  docHasValuesEntered(docType, sectionKey) {
    const doc: any = this.getDocByType(docType);

    if (!doc || !doc.sections) return false;

    const section: any = _.findWhere(doc.sections, {
      section_key: sectionKey,
    });

    if (!section || !section.fields) return false;

    return _.any(_.map(section.fields, (f: any) => f.field_value));
  }

  render() {
    const { app, dispatch, hurdle, onHide } = this.props;
    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        <DocEntry
          app={app}
          hurdle={hurdle}
          onHide={onHide}
          dispatch={dispatch}
          docType={DocTypes.HomeownersPolicy}
          docNotFoundMsg="Waiting for borrower(s) to upload their policy."
          onSave={this.onSave.bind(this)}
        />
      </HurdleView>
    );
  }
}

export default connect()(HazardInsuranceEditor);
